// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/pagination.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.portal.pagination";

export interface PaginationResponse {
  /** Presence implies availability of next page. Return BOTH when in the middle. */
  nextOld?:
    | string
    | undefined;
  /** pass as PaginationRequest.newer for more results */
  nextNew?: string | undefined;
  asOf?: string | undefined;
}

function createBasePaginationResponse(): PaginationResponse {
  return { nextOld: undefined, nextNew: undefined, asOf: undefined };
}

export const PaginationResponse: MessageFns<PaginationResponse> = {
  encode(message: PaginationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextOld !== undefined) {
      writer.uint32(10).string(message.nextOld);
    }
    if (message.nextNew !== undefined) {
      writer.uint32(18).string(message.nextNew);
    }
    if (message.asOf !== undefined) {
      Timestamp.encode(toTimestamp(message.asOf), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PaginationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePaginationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextOld = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextNew = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.asOf = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PaginationResponse {
    return {
      nextOld: isSet(object.nextOld)
        ? globalThis.String(object.nextOld)
        : isSet(object.next_old)
        ? globalThis.String(object.next_old)
        : undefined,
      nextNew: isSet(object.nextNew)
        ? globalThis.String(object.nextNew)
        : isSet(object.next_new)
        ? globalThis.String(object.next_new)
        : undefined,
      asOf: isSet(object.asOf)
        ? globalThis.String(object.asOf)
        : isSet(object.as_of)
        ? globalThis.String(object.as_of)
        : undefined,
    };
  },

  toJSON(message: PaginationResponse): unknown {
    const obj: any = {};
    if (message.nextOld !== undefined) {
      obj.nextOld = message.nextOld;
    }
    if (message.nextNew !== undefined) {
      obj.nextNew = message.nextNew;
    }
    if (message.asOf !== undefined) {
      obj.asOf = message.asOf;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PaginationResponse>, I>>(base?: I): PaginationResponse {
    return PaginationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PaginationResponse>, I>>(object: I): PaginationResponse {
    const message = createBasePaginationResponse();
    message.nextOld = object.nextOld ?? undefined;
    message.nextNew = object.nextNew ?? undefined;
    message.asOf = object.asOf ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
